import { render } from "./quranTem.vue?vue&type=template&id=35911140&scoped=true"
import script from "./quranTem.vue?vue&type=script&lang=js"
export * from "./quranTem.vue?vue&type=script&lang=js"

import "./quranTem.vue?vue&type=style&index=0&id=35911140&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35911140"]])

export default __exports__